import { createContext } from 'react'
import { CountriesContextValue } from './types'

export const CountriesContext = createContext<CountriesContextValue>({ countries: [] })
